import React from 'react';
import './index.css';

export function AcceptButtons(props) {
  return (
    <button data-testid={props.datatestid ? props.datatestid : "save-button"} style={{ background: props.background, color:props.color, boxShadow: props.boxShadow ? props.boxShadow : '0px 4px 4px rgba(0, 0, 0, 0.25)'}} disabled={props.disabled} className={props.className ? props.className : 'AcceptButtonsBtn'} onClick={props.onClick}>{props.children}</button>
  )
}

export default AcceptButtons;